"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _mdiMaterialUi = require("mdi-material-ui");
var _Banner = _interopRequireDefault(require("./Banner.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Banner = function Banner(_ref) {
  var _classnames;
  var title = _ref.title,
    body = _ref.body,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    _ref$borderPosition = _ref.borderPosition,
    borderPosition = _ref$borderPosition === void 0 ? 'left' : _ref$borderPosition,
    onChange = _ref.onChange,
    _ref$isCollapsible = _ref.isCollapsible,
    isCollapsible = _ref$isCollapsible === void 0 ? false : _ref$isCollapsible,
    open = _ref.open,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? true : _ref$defaultOpen;
  var controlled = open !== undefined;
  var classes = (0, _Banner.default)({
    type: type,
    isCollapsible: isCollapsible
  });
  var _useState = (0, _react.useState)(controlled ? !open : !defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  (0, _react.useEffect)(function () {
    if (controlled) {
      setCollapsed(!open);
    }
  }, [open, controlled]);

  // MISC
  var renderIcon = /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Information, {
    fontSize: "inherit"
  });
  if (type === 'danger') {
    renderIcon = /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Alert, {
      fontSize: "inherit"
    });
  } else if (type === 'success') {
    renderIcon = /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.CheckCircle, {
      fontSize: "inherit"
    });
  } else if (type === 'warning') {
    renderIcon = /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.AlertBox, {
      fontSize: "inherit"
    });
  }

  // EVENTS
  var handleCollapse = function handleCollapse(event) {
    if (isCollapsible) {
      if (onChange) {
        onChange(event, !collapsed);
      }
      if (!controlled) {
        setCollapsed(!collapsed);
      }
    }
  };
  var handleClick = function handleClick(event) {
    handleCollapse(event);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      handleCollapse(event);
    }
  };

  // STYLES
  var cssBanner = (0, _classnames2.default)(classes.banner, (_classnames = {}, _defineProperty(_classnames, classes.bannerCollapsible, isCollapsible), _defineProperty(_classnames, classes.borderLeft, borderPosition === 'left'), _defineProperty(_classnames, classes.borderTop, borderPosition === 'top'), _classnames));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cssBanner,
    tabIndex: 0,
    role: "button",
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.header,
    onClick: handleClick,
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.headerStart
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icon
  }, renderIcon), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title
  }, title)), /*#__PURE__*/_react.default.createElement("div", null, isCollapsible && body && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.collapseIcon
  }, collapsed ? /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.ChevronDown, {
    fontSize: "inherit"
  }) : /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.ChevronUp, {
    fontSize: "inherit"
  })))), !collapsed && body && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.body
  }, body));
};
var _default = Banner;
exports.default = _default;